import { create } from "@/store";
import MonitoringManager from "./MonitoringManager";

type Providing = typeof monitoring.providing;

const monitoring = new MonitoringManager();
const useViewerActions = create<Providing>()(() => monitoring.providing);

export { monitoring, useViewerActions };
